import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-797792be")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "home-title" }, "Bond", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "home-subtitle" }, "Earn premiums upon redemption", -1)
_popScopeId()

import { computed } from 'vue';

import AppHero from '@/components/heros/AppHero.vue';
import useFathom from '@/composables/useFathom';
import { EXTERNAL_LINKS } from '@/constants/links';
import useWeb3 from '@/services/web3/useWeb3';

import HeroConnectWalletButton from './HeroConnectWalletButton.vue';

/**
 * COMPOSABLES
 */

export default _defineComponent({
  setup(__props) {

const { isWalletReady, isWalletConnecting } = useWeb3();
const { trackGoal, Goals } = useFathom();

/**
 * COMPUTED
 */
const classes = computed(() => ({
  ['h-64']: !isWalletReady.value && !isWalletConnecting.value,
  ['h-44']: isWalletReady.value || isWalletConnecting.value,
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppHero, {
    class: _normalizeClass(_unref(classes))
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})